import "../../global";
import App from "./App";
import React from "react";
import { createRoot } from "react-dom/client";

const main = async () => {
  const params = new URLSearchParams(window.location.search);

  if (!params.has("siCartId")) {
    return;
  }

  const domNode = document.createElement("div");
  domNode.id = "si-cart-loader";
  const root = createRoot(domNode);

  const cartId = params.get("siCartId") || "";

  if(!cartId) {
    return;
  }


  root.render(<App cartId={cartId} />);
  document.body.appendChild(domNode);
};

window.addEventListener("load", main);
